import CONST_SUB_GENRE from 'features/SubGenre/constans';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useTranslation } from 'react-i18next';

interface FilterProps {
  handleChangeFairFlg: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  callFilter: () => void;
  name?: string;
  fairFlg?: number;
}

const fairFlgString: any = {
  '0': 'なしのみ表示',
  '1': 'ありのみ表示',
  '-1': '全て',
};

function Filter({ handleChangeFairFlg, handleChangeName, callFilter, name, fairFlg }: FilterProps) {
  const { t } = useTranslation();
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('SubGenreAddModal.search')}</Accordion.Header>
          <Accordion.Body>
            <Form.Group as={Row}>
              <Col sm={2} md={2} lg={2} xl={2}>
                {t('SubGenreAddModal.fair')}
              </Col>
              <Col sm={8} md={8} lg={8} xl={8}>
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_all')}
                  id="0"
                  defaultChecked={true}
                  onChange={handleChangeFairFlg}
                  name="fair_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.ALL}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_only_with')}
                  id="1"
                  onChange={handleChangeFairFlg}
                  name="fair_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.ONLY}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('SubGenre.Filter.show_none_only')}
                  id="2"
                  onChange={handleChangeFairFlg}
                  name="fair_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.NONE_ONLY}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={2} md={2} lg={2} xl={2}>
                {t('SubGenreAddModal.name')}
              </Col>
              <Col sm={8} md={8} lg={8} xl={8}>
                <Form.Control type="text" onChange={handleChangeName} />
              </Col>
              <Col sm={2} md={2} lg={2} xl={2}>
                <Button variant="primary" onClick={callFilter}>
                  {t('SubGenreAddModal.search')}
                </Button>
              </Col>
            </Form.Group>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('SubGenreAddModal.fair')} {fairFlgString[fairFlg ? fairFlg : 0]}
                </Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('SubGenreAddModal.name')} {name}
                </Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default Filter;
